import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  Output,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { JsonControl, JsonControlCustomOptions, JsonFormData } from '../model';

@Component({
  selector: 'jsonform-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  standalone: false,
})
export class FormComponent implements OnChanges, OnDestroy {
  @Input('formData') public datosFormulario: JsonControl[] = [];
  @Input('customOptions')
  public opcionesPersonalizadas: JsonControlCustomOptions = {};
  @Output('onChange') public alCambiar: EventEmitter<JsonFormData> =
    new EventEmitter();

  public formularioBase: FormGroup = new FormGroup({});
  public formularioCargado: boolean = false;
  private suscripcionCambiosFormulario?: Subscription;

  // Escucha los cambios del país en tiempo real
  ngOnChanges(cambios: SimpleChanges): void {
    if (cambios['datosFormulario'] && this.datosFormulario) {
      this.construirFormulario();
    }
  }

  ngOnDestroy(): void {
    this.suscripcionCambiosFormulario?.unsubscribe();
  }

  private construirFormulario(): void {
    this.suscripcionCambiosFormulario?.unsubscribe();
    this.formularioCargado = false;
    this.formularioBase = new FormGroup({}); // Reinicia el formulario limpio

    this.datosFormulario = this.datosFormulario
      .filter((controlJson) => controlJson && controlJson.name)
      .map((controlJson) => {
        const valorDefecto = controlJson.field?.default_value ?? '';
        const controlFormulario = new FormControl(valorDefecto);

        this.agregarValidadores(controlJson, controlFormulario);
        this.formularioBase.addControl(controlJson.name, controlFormulario);
        controlJson.formControl = controlFormulario;

        return controlJson;
      });

    this.formularioCargado = true;

    this.emitirEstadoFormulario();

    this.suscripcionCambiosFormulario = this.formularioBase.valueChanges.subscribe(
      (valores) =>
      this.alCambiar.emit({
        values: valores,
        invalid: this.formularioBase.invalid,
      }),
    );
  }

  private emitirEstadoFormulario(): void {
    this.alCambiar.emit({
      values: this.formularioBase.value,
      invalid: this.formularioBase.invalid,
    });
  }

  private agregarValidadores(
    controlJson: JsonControl,
    controlFormulario: FormControl,
  ): void {
    if (controlJson.field?.required)
      controlFormulario.addValidators(Validators.required);
    if (controlJson.field?.type === 'email')
      controlFormulario.addValidators(Validators.email);
  }
}
